import { Box, Breadcrumbs, Button, IconButton, } from "@mui/material"
import { useEffect, useMemo } from "react"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import { useStyles } from "./styles"
import { icons } from "../../utils/icons"
import { useTranslation } from "react-i18next"
import { formatRoot, formatBreadCrumb } from "./mthods"
import { BreadCrubProps } from "./types"
import { BreadCrumbKeys } from "./enum"
import { useBreadCrumbContext } from "./context/breadCrumbContext"
/* import { addBreadList } from "./mthods/routesHistory" */


const BreadCrumb = ({ Children, breadList = [], replaceLabels, removeBreadcrumb = [], replacePath, notAddPath }: BreadCrubProps) => {
    const navigate = useNavigate()
    const styles = useStyles()
    const { t } = useTranslation()
    const loaction = useLocation()
    const { id } = useParams()
    const { setBreadList } = useBreadCrumbContext();
    const listPaths = useMemo(() => {
        const queary = new URLSearchParams(loaction.search)
        const rootPath = queary.get(BreadCrumbKeys.ROOT)?.split(',') || []
        const equivalencePath = queary.get(BreadCrumbKeys.EQUIVALENCE)?.split(',') || []
        const routeFiltered = loaction.pathname.split('/').filter(path => !!path && !!isNaN(Number(path)))
        let list = routeFiltered.map(path => ({ label: path, path }))
        let listLenght = list.length
        let includePath = true
        if (listLenght <= 2 && !notAddPath) {
            const lastPath = list[listLenght - 1]
            list.push({
                label: `${lastPath.label}`,
                path: `${lastPath.path}`
            })
            listLenght = list.length
            includePath = false
        }
        if (id) {
            const lastPath = list[listLenght - 1]
            list[listLenght - 1] = {
                label: `${lastPath.label}Edit`,
                path: `${includePath ? `${lastPath.path}/` : ''}${id}`
            }
        }

        const formatBread = formatBreadCrumb({ list, equivalence: equivalencePath })
        //if exist queary params n the url the last path gonna staying those queries
        if (!!queary.toString()) {
            const lastPath = formatBread[listLenght - 1]
            formatBread[listLenght - 1] = {
                ...lastPath,
                path: `${lastPath.path}?${queary.toString()}`
            }
        }
        // if some external root exist will be include here
        if (rootPath?.length) {
            const rootFormated = formatRoot({ rootPath, replaceRoutes: loaction?.state?.replaceRoutes })
            return [...formatBread.slice(0, 1), ...rootFormated, ...formatBread.slice(1, listLenght)].filter(path => !removeBreadcrumb.includes(path.label))
        }

        return formatBread.filter(path => !removeBreadcrumb.includes(path.label))
    }, [removeBreadcrumb])

    useEffect(() => {
        setBreadList(listPaths);  // Actualiza la lista de migas de pan en el contexto
    }, [setBreadList]);
    return (
        <Box sx={styles.rootPathContainer}>
            <Breadcrumbs sx={styles.container} aria-label="breadcrumb">
                {!!breadList?.length && (
                    [{ id: '/dashboard', path: '/dashboard', active: false, label: '', navigate: () => { } }, ...breadList]?.map((path, index) => {
                        if (index == 0) {
                            return <IconButton key={path.path} LinkComponent={Link} className="home" to={path.path} >{icons('home')}</IconButton>
                        }
                        return (
                            <Button variant="text" onClick={() => { path.navigate() }} className={path?.active ? 'active' : 'unactive'} key={path.id}>
                                {t(`breadBrumbs.${path.label}`)}
                            </Button>
                        )
                    })
                )}

                {
                    !breadList?.length && listPaths?.map((path, index) => {
                        if (index == 0) {
                            return <IconButton key={path.path} LinkComponent={Link} className="home" to={path.path} >{icons('home')}</IconButton>
                        }
                        return (
                            <Button onClick={() => {
                                if (index == (listPaths?.length - 1)) return
                                if (path?.state) {
                                    navigate(replacePath?.[path.label] ?? path.path, { state: path?.state })
                                    return
                                }
                                navigate(replacePath?.[path.label] ?? path.path,)
                            }}>{t(`breadBrumbs.${replaceLabels?.[path.label] ?? path.label}`)}</Button>
                        )
                    })
                }
            </Breadcrumbs>

            {Children}
        </Box>
    )
}

export { BreadCrumb }